import React from 'react';
import { inject, observer } from 'mobx-react';

import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export var LanguagesMenu = inject('languagesStore')(observer(function (_ref) {
  var languagesStore = _ref.languagesStore,
      nav = _ref.nav;
  return React.createElement(
    UncontrolledDropdown,
    null,
    React.createElement(
      DropdownToggle,
      { caret: true, nav: !!nav },
      languagesStore.selectedLanguage.toUpperCase()
    ),
    React.createElement(
      DropdownMenu,
      null,
      languagesStore.languagesAvailable.map(function (language) {
        return React.createElement(
          DropdownItem,
          { key: language,
            active: language === languagesStore.selectedLanguage,
            onClick: languagesStore.selectLanguage(language) },
          (languagesStore.languages[language] || {}).name || language
        );
      })
    )
  );
}));